import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader, CSpinner, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter
} from '@coreui/react';

import { apiClient } from 'services/Api';
import { jwtDecode } from 'jwt-decode';
import DataTableComponent from "components/DataTableComponent";
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";
import ToastNotification from 'components/globals/ToastNotification';
import { triggerAlert } from 'components/globals/AlertNotification';

const IdiSurveyList = () => {
    const navigate = useNavigate();
    const [idiSurveys, setIdiSurveys] = useState([]);
    const location = useLocation();
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [availableYears, setAvailableYears] = useState([]);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(null);
    const [missingEmails, setMissingEmails] = useState(null);
    const [previewSurvey, setPreviewSurvey] = useState(null);

    const token = localStorage.getItem("access_token");
    const decodedToken = jwtDecode(token);
    const is_director = decodedToken.is_director;

    useEffect(() => {
        const fetchIdiSurveys = async (year = selectedYear) => {
            try {
                const response = await apiClient.get(`/idi-surveys/?year=${year}`);
                setIdiSurveys(response.data.idiSurveys);
                setAvailableYears(response.data.available_years);
            } catch (error) {
                console.error('Error fetching idi survey:', error);
            }
        };

        fetchIdiSurveys(selectedYear);
    }, [location.pathname, selectedYear]);

    const handleSendEmails = async () => {
        setLoading(true);

        try {
            //return; // Temporarily disabled the email sending functionality
            const response = await apiClient.post(`/idi-surveys/send-emails/`);
            setToast({ title: 'Inquéritos IDI', message: "Inquéritos enviados com sucesso", type: 'success' });
            if (response.data.missing_emails.length > 0) {
                setMissingEmails(response.data.missing_emails);
            }

            const updatedResponse = await apiClient.get(`/idi-surveys/?year=${selectedYear}`);
            setIdiSurveys(updatedResponse.data.idiSurveys);
            setAvailableYears(updatedResponse.data.available_years);
        } catch (error) {
            console.error("Error sending satisfaction surveys:", error);
            setToast({ title: 'Inquéritos IDI', message: "Erro ao enviar os inquéritos.", type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "Parceiro", selector: (row) => row.partnership_name, sortable: true, className: 'text-center', grow: 2 },
        { name: "Preenchido", selector: (row) => row.concluded ? "Sim" : "Não", sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <ToastNotification toast={toast} setToast={setToast} />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Inquéritos IDI</h3>

                    {is_director && (
                        <CButton color="info" className="text-white" onClick={handleSendEmails} disabled={loading}>
                            {loading ? (
                                <CSpinner size="sm" />
                            ) : (
                                "Enviar Inquéritos"
                            )}
                        </CButton>
                    )}
                </CCardHeader>

                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={idiSurveys}
                        years={availableYears}
                        selectedYear={selectedYear}
                        onYearChange={(newYear) => setSelectedYear(newYear)}
                        onRowClicked={setPreviewSurvey}
                    />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewSurvey}
                onHide={() => setPreviewSurvey(null)}
                title="Inquérito IDI"
                subtitle={previewSurvey?.partnership_name}
                fields={previewSurvey ? [
                    { label: "Parceiro", value: previewSurvey.partnership_name },
                    { label: "Preenchido", value: previewSurvey.concluded ? "Sim" : "Não" },
                ] : []}
                headerActions={previewSurvey && is_director && previewSurvey.concluded && (
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/inqueritos-idi/${previewSurvey.id}`)}>
                        Ver
                    </CButton>
                )}
            />

            {missingEmails && (
                <CModal visible={true} onClose={() => setMissingEmails(null)}>
                    <CModalHeader>
                        <CModalTitle>Parcerias sem email para envio de inquéritos</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <ul>
                            {missingEmails.map((partnership, idx) => (
                                <li key={idx}>{partnership}</li>
                            ))}
                        </ul>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setMissingEmails(null)}>
                            Fechar
                        </CButton>
                    </CModalFooter>
                </CModal>
            )}
        </>
    );
};

export default IdiSurveyList;
